import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TitleToolTip = ({
  title = "Sample Title",
  children,
  placement = "bottom",
}) => {
  const id = `${Math.random() * 10}-${title}`;

  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip id={id} className="title-tooltip">
          {title}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};

export default TitleToolTip;
